import { Box, Flex, chakra } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { parseUnits } from 'viem';

import chain from 'configs/app/chain';
import CurrencyValue from 'ui/shared/CurrencyValue';
import * as DetailsInfoItem from 'ui/shared/DetailsInfoItem';
import IconSvg from 'ui/shared/IconSvg';
import LinkExternal from 'ui/shared/links/LinkExternal';
import NativeTokenIcon from 'ui/shared/NativeTokenIcon';

import { ethToHaqq } from './convert-address';
import { useIndexerBalanceQuery } from './use-indexer-balance-query';

export const AddressVestedBalance = ({ address, exchangeRate }: {
  address: string;
  exchangeRate: string | null;
}) => {
  const bech32Address = ethToHaqq(address);
  const { data, isLoading, isError, refetch } = useIndexerBalanceQuery(bech32Address, true);
  const vestingPortalUrl = `https://vesting.haqq.network/account/${ address }`;
  // eslint-disable-next-line no-console
  console.log('AddressVestedBalance', { bech32Address, data, isLoading });

  const handleErrorClick = useCallback(() => {
    refetch();
  }, [ refetch ]);

  return (
    <>
      <DetailsInfoItem.Label hint="Vesting balance" isLoading={ isLoading }>
        Vested
      </DetailsInfoItem.Label>

      { isError ? (
        <DetailsInfoItem.Value alignSelf="center" flexWrap="nowrap">
          <IconSvg name="status/error" boxSize={ 5 } color="red.500" mr={ 2 }/>;
          <chakra.span display="inline-flex" rowGap={ 3 } columnGap={ 1 }>
            <chakra.span display="inline-block" onClick={ handleErrorClick }>
              Something went wrong. Click to retry.
            </chakra.span>
          </chakra.span>
        </DetailsInfoItem.Value>
      ) : (
        <DetailsInfoItem.Value alignSelf="center" flexWrap="nowrap">
          <Flex columnGap={ 3 } direction="row" alignItems="center">
            <Flex direction="row" alignItems="center">
              <NativeTokenIcon boxSize={ 6 } mr={ 2 } isLoading={ isLoading }/>
              <CurrencyValue
                value={ parseUnits(data?.vested.toString() || '0', chain.currency.decimals) }
                exchangeRate={ exchangeRate }
                decimals={ String(chain.currency.decimals) }
                currency={ chain.currency.symbol }
                accuracyUsd={ 2 }
                accuracy={ 8 }
                flexWrap="wrap"
                isLoading={ isLoading }
              />
            </Flex>
            <Box>
              <LinkExternal href={ vestingPortalUrl }>Vesting portal</LinkExternal>
            </Box>
          </Flex>
        </DetailsInfoItem.Value>
      ) }
    </>
  );
};

export default React.memo(AddressVestedBalance);
